import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import type { UploadContractData } from "../types/uploadContract";
import withPrefix from "../../../helpers/useQueryPrefix";
import { editContract } from "../apis/editContract";

export const useEditContract = (): UseMutationResult<ApiResponse, ApiError, UploadContractData> => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: editContract,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: withPrefix(['contracts']) });
        }
    })
}
